import { X } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ReloadButton } from "@/components/shell/reload-boundary"
import { Button } from "@/components/ui/primitives"
import { useAppOutdated } from "@/hooks/use-app-outdated"

/** Ненавязчивая плашка после деплоя: работать можно дальше, но свежая сборка — по кнопке. */
export function AppUpdateBanner() {
  const { t } = useTranslation("layout")
  const outdated = useAppOutdated()
  const [dismissed, setDismissed] = useState(false)
  if (!outdated || dismissed) return null

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-[260] flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-lg border border-ui-border-opaque bg-ui-bg-elevated py-2 pr-2 pl-4 text-sm text-ui-text-primary shadow-[var(--ui-shadow-md)]"
    >
      <span className="min-w-0 truncate">{t("appReload.bannerText")}</span>
      <ReloadButton className="shrink-0" />
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-8 w-8 shrink-0"
        aria-label={t("appReload.bannerDismiss")}
        onClick={() => setDismissed(true)}
      >
        <X className="h-4 w-4" aria-hidden />
      </Button>
    </div>
  )
}
